import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { interpret } from "xstate";
import Loader from "@/components/widgets/loader.vue";
import EcPieChart from "@/components/widgets/EcPieChart.vue";
import simplebar from "simplebar-vue";
import clockWorkPieChartMachine from "./machines/clockWorkPieChartMachine";
let ClockWorkPieChart = /** @class */ (() => {
    var _a, _b;
    let ClockWorkPieChart = class ClockWorkPieChart extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.pageIsLoading = false;
            //   MACHINE
            this.machine = clockWorkPieChartMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.daySeries = [];
            this.dayLabels = [];
            this.weekSeries = [];
            this.weekLabels = [];
            this.daySummaries = [];
            this.weekSummaries = [];
            this.formattedDate = {
                dateOfMonth: "",
                suffixOfDate: "",
                month: "",
                year: "",
                day: "",
            };
        }
        send(event) {
            this.machineService.send(event);
        }
        getFormattedDateString(value) {
            return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}T00:00:00`;
        }
        showModal() {
            const operationDate = this.getFormattedDateString(this.today);
            this.send({ type: "GETTING_PROJECTS", operationDate: operationDate });
            this.$bvModal.show("project-pie-chart");
        }
        isCurrentWeek() {
            const today = new Date();
            const startOfWeek = this.getStartOfWeek(this.today);
            const endOfWeek = this.getEndOfWeek(this.today);
            return today >= startOfWeek && today <= endOfWeek;
        }
        getStartOfWeek(selectedDate) {
            let diff = selectedDate.getDay() - 1;
            if (diff < 0) {
                diff += 7;
            }
            return new Date(selectedDate.getTime() - diff * 24 * 60 * 60 * 1000);
        }
        getEndOfWeek(selectedDate) {
            let diff = 7 - selectedDate.getDay();
            return new Date(selectedDate.getTime() + diff * 24 * 60 * 60 * 1000);
        }
        closeModal() {
            this.send({ type: "CLOSE_MODAL" });
            this.$bvModal.hide("project-pie-chart");
        }
        updateSeriesData() {
            this.daySeries = this.daySummaries.map((project) => project.totalTimeInMinutes);
            this.dayLabels = this.daySummaries.map((project) => project.projectName);
            this.weekSeries = this.weekSummaries.map((project) => project.totalTimeInMinutes);
            this.weekLabels = this.weekSummaries.map((project) => project.projectName);
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("gettingProjectDetails")) {
                    this.pageIsLoading = true;
                }
                if (this.state.matches("loadedProjectDetails")) {
                    this.pageIsLoading = false;
                    this.updateSeriesData();
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], ClockWorkPieChart.prototype, "daySummaries", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], ClockWorkPieChart.prototype, "weekSummaries", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
    ], ClockWorkPieChart.prototype, "today", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_b = typeof Number !== "undefined" && Number) === "function" ? _b : Object)
    ], ClockWorkPieChart.prototype, "totalTime", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "unAssignedEntriesTime", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "workFromOfficeEntriesTime", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "workFromHomeEntriesTime", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], ClockWorkPieChart.prototype, "totalWeekEntries", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "unassignedWeekEntriesTime", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "workFromOfficeWeekEntriesTime", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "workFromHomeWeekEntriesTime", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "formattedDate", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "formattedWeekTotalTime", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "weekStartDate", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClockWorkPieChart.prototype, "weekEndDate", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], ClockWorkPieChart.prototype, "isToday", void 0);
    ClockWorkPieChart = __decorate([
        Component({
            name: "clockWorkPieChart",
            components: {
                Loader,
                simplebar,
                EcPieChart,
            },
        })
    ], ClockWorkPieChart);
    return ClockWorkPieChart;
})();
export default ClockWorkPieChart;
